module.exports = __webpack_public_path__ + "img/code.201e8d44.png";